import {Pipe} from '@angular/core';

@Pipe({
  name: 'intl'
})
export class IntlPipe {
  transform(value: Object, lg: string) : string {
    if(value)
      return value[lg];
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/intl.pipe.ts